import React, { useEffect, useState } from "react";
import {
  FormControlLabel,
  Grid,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  TextField,
  Typography,
} from "@mui/material";

const AMLComponent = ({ practice = {}, onPracticeUpdate, errors }) => {
  const [AmlValueRadio, setAmlValueRadio] = useState("");
  let AML = JSON.parse(localStorage.getItem("AML"));

  useEffect(() => {
    if (practice.AML) {
      localStorage.setItem(
        "AML",
        JSON.stringify(practice?.AML?.controlli_AML || "")
      );
    }
  }, []);

  const handlePracticeChange = (name, value) => {
    if (name === "controlli_AML") {
      localStorage.setItem("AML", JSON.stringify(value));
    }

    if (value === "No") {
      const updatedPractice = {
        ...practice,
        AML: {
          controlli_AML: "No",
        },
      };

      onPracticeUpdate(updatedPractice);
    } else {
      const updatedPractice = {
        ...practice,
        AML: {
          ...practice?.AML,
          [name]: value,
        },
      };

      onPracticeUpdate(updatedPractice);
    }
  };

  const handlePracticeAml_Si = (name, value) => {
    if (name === "controlli_AML") {
      localStorage.setItem("AML", JSON.stringify(value));
    }

    if (value === "No") {
      const updatedPractice = {
        ...practice,
        AML: {
          controlli_AML: "Sì",
          tipologia_verifica: "Ordinaria",
          livello_rischio: "Medio",
        },
      };

      onPracticeUpdate(updatedPractice);
    } else {
      const updatedPractice = {
        ...practice,
        AML: {
          ...practice?.AML,
          [name]: value,
        },
      };

      onPracticeUpdate(updatedPractice);
    }
  };

  const livello_rischio_array = ["Medio", "Alto"];
  const tipologia_verifica_array = ["Ordinaria", "Rafforzata"];

  return (
    <Grid
      container
      style={{
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Grid
        item
        xs={11}
        sm={10}
        style={{
          overflowY: "auto",
          marginTop: "30px",
        }}
      >
        {/* Title */}
        <Grid
          xs={12}
          spacing={4}
          item
          container
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Grid item xs={11} md={4}>
            <Typography className="color-blue-dark title-step">AML</Typography>
          </Grid>

          <Grid item xs={11} md={4} style={{ paddingTop: "0px" }}></Grid>

          <Grid item xs={11} md={4} style={{ paddingTop: "0px" }}></Grid>
        </Grid>

        <Grid
          xs={12}
          item
          container
          sx={{
            display: "flex",
            justifyContent: { xs: "center", md: "flex-start" },
            marginBottom: "50px",
            marginTop: "2px",
          }}
        >
          <Grid
            item
            xs={11}
            md={12}
            style={{
              backgroundColor: "#d3d3d382",
              marginTop: "40px",
              padding: "20px",
              border: errors.includes("controlli_AML")
                ? "1px solid #bc2957"
                : "none",
            }}
          >
            {practice.Incarico.Prodotto_richiesto.AML_scelta_default ===
              "Sì" && (
              <>
                <Typography
                  style={{ fontWeight: 500 }}
                  className="color-blue-dark"
                >
                  Per il prodotto selezionato per questa pratica, la policy
                  antiriciclaggio dello Studio{" "}
                  <span style={{ fontWeight: "bold" }}>
                    prevede controlli AML
                  </span>{" "}
                  sul cliente.
                </Typography>
                <Typography
                  style={{ fontWeight: 500 }}
                  className="color-blue-dark"
                >
                  Nello specifico, sono associati al cliente una tipologia di
                  verifica <span style={{ fontWeight: "bold" }}>ORDINARIA</span>{" "}
                  e un livello di rischio{" "}
                  <span style={{ fontWeight: "bold" }}>MEDIO</span>.
                </Typography>
                <Typography
                  style={{ fontWeight: 500 }}
                  className="color-blue-dark"
                >
                  Per eventuali chiarimenti puoi consultare la policy
                  antiriciclaggio disponibile a{" "}
                  <a
                    className="color-purple"
                    href="/Procedura_AML.pdf"
                    download="LEXIA-Procedura-AML.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    questo link
                  </a>{" "}
                  o contattare l'amministrazione.
                </Typography>
                <Typography
                  style={{ fontWeight: 500 }}
                  className="color-blue-dark"
                >
                  Non puoi derogare alle verifiche antiriciclaggio. In base alla
                  tua sensibilità, puoi però modificare la tipologia di verifica
                  e/o il livello di rischio.
                </Typography>
                <Typography
                  style={{ marginTop: "10px", fontWeight: 500 }}
                  className="color-blue-dark"
                >
                  Vuoi modificare questi parametri?
                </Typography>

                <RadioGroup
                  row
                  aria-label="AML-check"
                  name="controlli_AML"
                  value={AML || ""}
                  onChange={(e) =>
                    handlePracticeAml_Si(e.target.name, e.target.value)
                  }
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <FormControlLabel
                      value="Sì"
                      control={<Radio className="color-blue-dark" />}
                      label="Sì"
                    />
                    <FormControlLabel
                      value="No"
                      control={
                        <Radio className="color-blue-dark" color="primary" />
                      }
                      label="No"
                    />
                  </div>
                </RadioGroup>
              </>
            )}

            {practice.Incarico.Prodotto_richiesto.AML_scelta_default ===
              "No" && (
              <>
                <Typography
                  style={{ fontWeight: 500 }}
                  className="color-blue-dark"
                >
                  Per il prodotto selezionato per questa pratica, la policy
                  antiriciclaggio dello Studio{" "}
                  <span style={{ fontWeight: "bold" }}>
                    non prevede alcun controllo sul cliente
                  </span>
                  , come scelta indicativa.
                </Typography>
                <Typography
                  style={{ fontWeight: 500 }}
                  className="color-blue-dark"
                >
                  Tuttavia, la stessa policy rimette alla tua responsabilità la
                  decisione se adempiere agli obblighi previsti dalla normativa
                  applicabile, ivi incluso per quanto riguarda l'attività di
                  identificazione e adeguata verifica del cliente, considerata
                  la tipologia di prestazione richiesta e il rischio di
                  riciclaggio o di finanziamento del terrorismo connesso alla
                  pratica.
                </Typography>
                <Typography
                  style={{ fontWeight: 500 }}
                  className="color-blue-dark"
                >
                  Per eventuali chiarimenti puoi consultare la policy
                  antiriciclaggio disponibile a{" "}
                  <a
                    className="color-purple"
                    href="/Procedura_AML.pdf"
                    download="LEXIA-Procedura-AML.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    questo link
                  </a>{" "}
                  o contattare l'amministrazione.
                </Typography>

                <Typography
                  style={{ marginTop: "10px", fontWeight: 500 }}
                  className="color-blue-dark"
                >
                  Vuoi effettuare i controlli AML sul cliente?
                </Typography>

                <RadioGroup
                  row
                  aria-label="AML-check"
                  name="controlli_AML"
                  value={AML || ""}
                  onChange={(e) =>
                    handlePracticeChange(e.target.name, e.target.value)
                  }
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <FormControlLabel
                      value="Sì"
                      control={<Radio className="color-blue-dark" />}
                      label="Sì"
                    />
                    <FormControlLabel
                      value="No"
                      control={
                        <Radio className="color-blue-dark" color="primary" />
                      }
                      label="No"
                    />
                  </div>
                </RadioGroup>
              </>
            )}

            {practice.Incarico.Prodotto_richiesto.AML_scelta_default ===
              "TBC" && (
              <>
                <Typography
                  style={{ fontWeight: 500 }}
                  className="color-blue-dark"
                >
                  In base alla policy antiriciclaggio dello Studio{" "}
                  <span style={{ fontWeight: "bold" }}>
                    è rimessa alla tua responsabilità la decisione
                  </span>{" "}
                  se adempiere agli obblighi previsti dalla normativa
                  applicabile, ivi incluso per quanto riguarda l'attività di
                  identificazione e adeguata verifica del cliente, considerata
                  la tipologia di prestazione richiesta e il rischio di
                  riciclaggio o di finanziamento del terrorismo connesso alla
                  pratica.
                </Typography>
                <Typography
                  style={{ fontWeight: 500 }}
                  className="color-blue-dark"
                >
                  Per eventuali chiarimenti puoi consultare la policy
                  antiriciclaggio disponibile a{" "}
                  <a
                    className="color-purple"
                    href="/Procedura_AML.pdf"
                    download="LEXIA-Procedura-AML.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    questo link
                  </a>{" "}
                  o contattare l'amministrazione.
                </Typography>
                <Typography
                  style={{ marginTop: "10px", fontWeight: 500 }}
                  className="color-blue-dark"
                >
                  Vuoi effettuare i controlli AML sul cliente?
                </Typography>

                <RadioGroup
                  row
                  aria-label="AML-check"
                  name="controlli_AML"
                  value={AML || ""}
                  onChange={(e) =>
                    handlePracticeChange(e.target.name, e.target.value)
                  }
                >
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <FormControlLabel
                      value="Sì"
                      control={<Radio className="color-blue-dark" />}
                      label="Sì"
                    />
                    <FormControlLabel
                      value="No"
                      control={
                        <Radio className="color-blue-dark" color="primary" />
                      }
                      label="No"
                    />
                  </div>
                </RadioGroup>
              </>
            )}
          </Grid>

          {AML === "Sì" ? (
            <>
              <Grid
                container
                item
                xs={11}
                sx={{
                  marginTop: "50px",
                  marginBottom: "50px",
                  display: "flex",
                  justifyContent: { xs: "center", md: "space-between" },
                }}
              >
                <Grid item xs={12} md={5.5}>
                  <div
                    style={{
                      height: "20px",
                    }}
                  >
                    <Typography className="color-blue-dark title-input">
                      Tipologia di verifica
                    </Typography>
                  </div>

                  <Select
                    style={{
                      marginTop: "10px",
                    }}
                    error={errors.includes("tipologia_verifica")}
                    displayEmpty
                    fullWidth
                    name="tipologia_verifica"
                    value={practice?.AML?.tipologia_verifica || ""}
                    onChange={(e) =>
                      handlePracticeChange(e.target.name, e.target.value)
                    }
                  >
                    <MenuItem value="">
                      <span style={{ color: "#abb0b6" }}>Seleziona</span>
                    </MenuItem>
                    {tipologia_verifica_array.map((option, index) => (
                      <MenuItem key={index} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={5.5}
                  sx={{
                    marginTop: { xs: "20px", md: "0px" },
                  }}
                >
                  <div style={{ display: "flex", height: "20px" }}>
                    <Typography className="color-blue-dark title-input">
                      Livello di rischio
                    </Typography>
                  </div>

                  <Select
                    style={{
                      marginTop: "10px",
                    }}
                    error={errors.includes("livello_rischio")}
                    displayEmpty
                    fullWidth
                    name="livello_rischio"
                    value={practice?.AML?.livello_rischio || ""}
                    onChange={(e) =>
                      handlePracticeChange(e.target.name, e.target.value)
                    }
                  >
                    <MenuItem value="">
                      <span style={{ color: "#abb0b6" }}>Seleziona</span>
                    </MenuItem>
                    {livello_rischio_array.map((option, index) => (
                      <MenuItem key={index} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </Grid>
              </Grid>
            </>
          ) : null}
        </Grid>
      </Grid>
    </Grid>
  );
};

export default AMLComponent;
